export { default } from './RadarChart.js';
